import React from 'react';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';
import {
  deleteMotivoDeReintegro, getMotivosDeReintegro, patchMotivoDeReintegro, postMotivoDeReintegro,
} from 'api/recaudacion/motivosDeReintego';

// eslint-disable-next-line react/prop-types
const MotivosDeReintegro = ({ permission }) => (
  <PlainCRUD
    title="Motivo de Reintegro"
    permission={permission}
    get={getMotivosDeReintegro}
    post={postMotivoDeReintegro}
    patch={patchMotivoDeReintegro}
    delete={deleteMotivoDeReintegro}
    fields={[
      defaultFields.clave,
      defaultFields.descripcion,
      defaultFields.observaciones,
    ]}
  />
);

export default MotivosDeReintegro;
